// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { PROGRESS_STATUSES } from 'symbols';
import { MediatorService } from '../../services/mediator.service';
import { GetMediators } from './mediators.actions';
import { MEDIATORS_STATE_DEFAULT, MediatorsStateModel } from './mediators.model';

@State({ name: 'Mediators', defaults: MEDIATORS_STATE_DEFAULT })
@Injectable()
export class MediatorsState {

  constructor(private service: MediatorService) {
  }

  @Selector()
  static mediatorList(state: MediatorsStateModel): MediatorsStateModel['mediatorList'] {
    return state.mediatorList;
  }

  @Selector()
  static loadMediatorStatus(state: MediatorsStateModel): MediatorsStateModel['loadMediatorStatus'] {
    return state.loadMediatorStatus;
  }

  @Action(GetMediators)
  getMediators(ctx: StateContext<MediatorsStateModel>, { search }: GetMediators): void {
    ctx.patchState({
      loadMediatorStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.getMediators(search, 200).subscribe({
      next: (mediators) => {
        ctx.patchState({
          mediatorList: mediators,
          loadMediatorStatus: PROGRESS_STATUSES.SUCCESS
        });
      },
      error: () => {
        ctx.patchState({
          loadMediatorStatus: PROGRESS_STATUSES.FAIL
        });
      }
    });
  }
}


